"use client";

import React from "react";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";

import { Subscribe } from "@/components";

const BlogSubscribe = () => {
  return (
    <section className="lg:px-28 px-6 max-w-screen-2xl mx-auto mt-24">
      <div className="max-w-screen-2xl mx-auto">
        <div className="grid lg:grid-cols-[1.1fr_.9fr] gap-6">
          {/* LEFT MAIN CARD */}
          <motion.div
            className="
              relative overflow-hidden

              rounded-[36px]

              bg-primary
              dark:bg-primary-50

              px-7 py-8
              md:px-10 md:py-10

              min-h-[420px]

              shadow-[0_25px_60px_-20px_rgba(0,0,0,0.18)]
            "
            data-aos="fade-up"
            data-aos-duration="1000"
            initial={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            {/* glow */}
            <div
              className="
                absolute top-0 right-0
                h-56 w-56
                rounded-full
                bg-white/10
                blur-3xl
              "
            />

            {/* decorative shapes */}
            <div
              className="
                absolute -bottom-10 -right-10
                h-44 w-44
                rounded-[40px]
                rotate-12

                border border-white/10
                bg-white/5
                backdrop-blur-xl
              "
            />

            {/* badge */}
            <div
              className="
                inline-flex items-center gap-2

                rounded-full

                bg-white/15
                backdrop-blur-md

                px-4 py-2

                text-sm font-medium
                text-white
              "
            >
              <Icon icon="solar:case-round-bold" />
              Careers & Leadership
            </div>

            {/* heading */}
            <h2
              className="
                mt-8

                max-w-lg

                text-lg
                md:text-xl
                lg:text-3xl

                font-black
                leading-[0.95]
                tracking-tight

                text-white
              "
            >
              Get recruitment & CEO insights before everyone else
            </h2>

            {/* text */}
            <p
              className="
                mt-6

                max-w-xl

                text-sm
                md:text-base

                leading-8

                text-white/75
              "
            >
              Discover hiring updates, career opportunities, workplace culture,
              startup growth stories, and leadership lessons directly from the
              Cotton team.
            </p>

            {/* feature pills */}
            <div className="mt-8 flex flex-wrap gap-3">
              {[
                "Remote Jobs",
                "Career Growth",
                "CEO Insights",
                "Startup Culture",
              ].map((item) => (
                <div
                  key={item}
                  className="
                    rounded-full

                    border border-white/10

                    bg-white/10
                    backdrop-blur-md

                    px-4 py-2

                    text-sm text-white
                  "
                >
                  {item}
                </div>
              ))}
            </div>

            {/* form */}
            <div className="mt-10 max-w-xl">
              <Subscribe />
            </div>

            {/* floating orb */}
            <div
              className="
                absolute top-12 right-10

                hidden md:flex

                h-32 w-32

                items-center justify-center

                rounded-[30px]

                bg-gradient-to-br
                from-white/30
                to-white/5

                backdrop-blur-xl

                rotate-12
              "
            >
              <Icon
                className="text-6xl text-white/80"
                icon="solar:users-group-rounded-bold"
              />
            </div>
          </motion.div>

          {/* RIGHT COLUMN */}
          <div className="grid gap-6">
            {/* top mini card */}
            <motion.div
              className="
                relative overflow-hidden

                rounded-[32px]

                border border-default-200

                bg-default-50
                dark:bg-default-100/5

                p-6

                min-h-[190px]
              "
              data-aos="fade-left"
              data-aos-delay="100"
              data-aos-duration="1000"
              initial={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              whileInView={{ opacity: 1, x: 0 }}
            >
              <div
                className="
                  absolute top-0 right-0
                  h-40 w-40
                  rounded-full
                  bg-primary/10
                  blur-3xl
                "
              />

              <div className="relative z-10">
                <div
                  className="
                    inline-flex items-center gap-2

                    rounded-full

                    bg-primary/10
                    dark:bg-primary/15

                    px-3 py-1.5

                    text-xs font-medium
                    text-primary
                  "
                >
                  Founder Journal
                </div>

                <h3
                  className="
                    mt-5

                    text-xl
                    font-black
                    leading-tight

                    text-foreground
                  "
                >
                  Learn directly from startup leadership
                </h3>

                <p
                  className="
                    mt-3

                    text-sm leading-7

                    text-foreground-600
                  "
                >
                  Real lessons from building teams, scaling products, and
                  growing modern companies.
                </p>
              </div>
            </motion.div>

            {/* bottom card */}
            <motion.div
              className="
                relative overflow-hidden

                rounded-[32px]

                border border-default-200

                bg-background

                p-6
              "
              data-aos="fade-left"
              data-aos-delay="200"
              data-aos-duration="1000"
              initial={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              whileInView={{ opacity: 1, x: 0 }}
            >
              {/* decorative grid */}
              <div
                className="
                  absolute inset-0 opacity-[0.04]

                  bg-[linear-gradient(to_right,#000_1px,transparent_1px),linear-gradient(to_bottom,#000_1px,transparent_1px)]

                  dark:bg-[linear-gradient(to_right,#fff_1px,transparent_1px),linear-gradient(to_bottom,#fff_1px,transparent_1px)]

                  bg-[size:28px_28px]
                "
              />

              <div className="relative z-10">
                {/* tags */}
                <div className="flex flex-wrap gap-2">
                  {["Recruitment", "Remote Work", "Leadership"].map((tag) => (
                    <div
                      key={tag}
                      className="
                        rounded-full

                        bg-default-100
                        dark:bg-default-100/10

                        px-3 py-1

                        text-xs
                        text-foreground-600
                      "
                    >
                      {tag}
                    </div>
                  ))}
                </div>

                {/* content */}
                <h3
                  className="
                    mt-6

                    text-xl
                    font-black
                    leading-tight

                    text-foreground
                  "
                >
                  Explore careers, jobs & startup opportunities
                </h3>

                <p
                  className="
                    mt-4

                    text-base
                    leading-8

                    text-foreground-600
                  "
                >
                  Stay updated with new openings, company culture stories,
                  recruitment advice, and workplace innovation trends.
                </p>

                {/* stats */}
                <div className="mt-8 flex items-center justify-between">
                  <div className="flex -space-x-3">
                    {[1, 2, 3, 4].map((item) => (
                      <div
                        key={item}
                        className="
                          flex h-10 w-10
                          items-center justify-center

                          rounded-full

                          border-2 border-background

                          bg-primary/20

                          text-xs font-bold
                          text-primary
                        "
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSubscribe;
